import React from 'react';
import PropTypes from 'prop-types';
import Stats from './Stats';
import Description from './Description';

import './style.scss';

const StatsDesc = (props) => {
    const {
        description,
        recentDelivery,
        countryCode,
        memberSince,
        responseTime
    } = props;

    return (
        <div className="stats-desc">
            <Stats countryCode={countryCode}
                memberSince={memberSince}
                responseTime={responseTime} r
                ecentDelivery={recentDelivery}/>
            {description &&
            <Description userDescription={description}/>
            }
        </div>
    );
};

StatsDesc.propTypes = {
    description: PropTypes.string,
    recentDelivery: PropTypes.number,
    countryCode: PropTypes.string,
    memberSince: PropTypes.number,
    responseTime: PropTypes.number
};

export default StatsDesc;
